import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function NotFoundIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <svg
        fill="none"
        height="129"
        viewBox="0 0 134 129"
        width="134"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_5_57400)">
          <path
            d="M63.71 128.5c34.288 0 62.084-27.753 62.084-61.989 0-34.235-27.796-61.988-62.084-61.988-34.289 0-62.085 27.753-62.085 61.988 0 34.236 27.796 61.989 62.085 61.989Z"
            fill="url(#a)"
          />
          <path
            d="M97.204 18.947H28.427c-4.287 0-7.762 3.47-7.762 7.75h84.301c0-4.28-3.475-7.75-7.762-7.75Z"
            fill="url(#b)"
          />
          <path
            d="M20.665 26.486h84.301V90.59a10.74 10.74 0 0 1-3.152 7.6 10.773 10.773 0 0 1-7.611 3.147H31.428a10.771 10.771 0 0 1-7.61-3.147 10.738 10.738 0 0 1-3.153-7.6V26.486Z"
            fill="url(#c)"
          />
          <path
            d="M90.475 87.592H35.183a2.082 2.082 0 0 0-2.085 2.08c0 1.148.934 2.08 2.085 2.08h55.292a2.082 2.082 0 0 0 2.085-2.08c0-1.149-.933-2.08-2.085-2.08Z"
            fill="url(#d)"
          />
          <path
            d="M90.475 69.922H35.183a2.082 2.082 0 0 0-2.085 2.08c0 1.148.934 2.08 2.085 2.08h55.292a2.082 2.082 0 0 0 2.085-2.08c0-1.148-.933-2.08-2.085-2.08Z"
            fill="url(#e)"
          />
          <path
            d="M34.809 66.132H5.367a4.28 4.28 0 0 0-4.283 4.277v42.017a4.28 4.28 0 0 0 4.283 4.277h29.442a4.28 4.28 0 0 0 4.282-4.277V70.409a4.28 4.28 0 0 0-4.282-4.277Z"
            fill="url(#f)"
          />
          <path
            d="M31.536 106.779H8.862c-.764 0-1.383.604-1.383 1.349v.004c0 .745.619 1.349 1.383 1.349h22.674c.764 0 1.383-.604 1.383-1.349v-.004c0-.745-.62-1.349-1.383-1.349Z"
            fill="url(#g)"
          />
          <path
            d="M31.536 96.51H8.862c-.764 0-1.383.604-1.383 1.35v.004c0 .745.619 1.349 1.383 1.349h22.674c.764 0 1.383-.604 1.383-1.35v-.004c0-.745-.62-1.349-1.383-1.349Z"
            fill="url(#h)"
          />
          <path
            d="m105.377 89.14-7.99 8.795 22.52 20.395 7.989-8.795-22.519-20.394Z"
            fill="url(#i)"
          />
          <path
            d="M98.048 115.828c1.307-.331 2.482.876 2.115 2.173l-.705 2.498c-.366 1.297-2 1.711-2.94.745l-1.81-1.859c-.94-.966-.482-2.588.825-2.919l2.515-.638Z"
            fill="url(#j)"
          />
          <path
            d="m119.905 118.331 7.989-8.795 1.204 1.09a5.929 5.929 0 0 1 .409 8.383 5.952 5.952 0 0 1-8.396.408l-1.203-1.09-.003.004Z"
            fill="#6C737F"
          />
          <path
            d="M31.523 87.153H8.652c-.77 0-1.395.623-1.395 1.392v.004c0 .77.625 1.393 1.395 1.393h22.871c.77 0 1.395-.623 1.395-1.392v-.005c0-.769-.624-1.392-1.395-1.392Z"
            fill="url(#k)"
          />
          <path
            d="M17.015 72.621H10.33a2.679 2.679 0 0 0-2.68 2.677v1.852c0 1.478 1.2 2.676 2.68 2.676h6.684c1.48 0 2.68-1.198 2.68-2.676v-1.852c0-1.479-1.2-2.677-2.68-2.677Z"
            fill="url(#l)"
          />
          <path
            d="M90.475 52.253H35.183a2.082 2.082 0 0 0-2.085 2.08c0 1.148.934 2.079 2.085 2.079h55.292a2.082 2.082 0 0 0 2.085-2.08c0-1.148-.933-2.08-2.085-2.08Z"
            fill="url(#m)"
          />
          <path
            clipRule="evenodd"
            d="M113.82 74.585c0 18.398-14.938 33.312-33.364 33.312-18.426 0-33.364-14.914-33.364-33.312 0-18.398 14.938-33.312 33.364-33.312 18.426 0 33.364 14.914 33.364 33.312Zm-5.118 0c0 15.576-12.646 28.202-28.246 28.202-15.6 0-28.247-12.626-28.247-28.202 0-15.576 12.647-28.203 28.247-28.203s28.246 12.627 28.246 28.203Z"
            fill="url(#n)"
            fillRule="evenodd"
          />
          <path
            d="M58.051 112.573c.494-2.046 3.404-2.046 3.898 0a2.003 2.003 0 0 0 1.478 1.478c2.046.494 2.046 3.404 0 3.898a2.003 2.003 0 0 0-1.478 1.478c-.494 2.046-3.404 2.046-3.898 0a2.003 2.003 0 0 0-1.478-1.478c-2.046-.494-2.046-3.404 0-3.898a2.003 2.003 0 0 0 1.478-1.478Z"
            fill="url(#o)"
          />
          <g filter="url(#p)">
            <path
              d="M80.456 102.787c15.6 0 28.246-12.626 28.246-28.202 0-15.576-12.646-28.203-28.246-28.203-15.6 0-28.246 12.627-28.246 28.203 0 15.576 12.646 28.202 28.246 28.202Z"
              fill="url(#q)"
              fillOpacity=".2"
            />
          </g>
          <path
            d="m87.243 74.585 8.078-8.084a4.223 4.223 0 0 0-.083-5.891 4.236 4.236 0 0 0-5.9-.084L81.24 68.61l-8.078-8.084a4.232 4.232 0 0 0-4.669-1.013 4.232 4.232 0 0 0-2.64 3.976 4.22 4.22 0 0 0 1.325 3.012l8.092 8.084-8.092 8.083a4.226 4.226 0 0 0-1.015 4.662 4.227 4.227 0 0 0 3.982 2.637 4.239 4.239 0 0 0 3.017-1.324l8.096-8.083 8.096 8.083a4.237 4.237 0 0 0 5.796-.187 4.224 4.224 0 0 0 .17-5.788l-8.078-8.083Z"
            fill="#4D5761"
          />
          <g filter="url(#r)">
            <ellipse cx="81" cy="89.5" fill="#1F2A37" fillOpacity=".56" rx="19.5" ry="3" />
          </g>
          <path
            d="M120.827 59.946c-.333-1.306.873-2.482 2.171-2.118l2.498.702c1.298.365 1.714 1.997.749 2.939l-1.857 1.812c-.964.942-2.586.486-2.919-.82l-.642-2.515Z"
            fill="url(#s)"
          />
          <path
            d="M8.048 50.828c1.307-.331 2.482.876 2.116 2.173L9.458 55.5c-.366 1.297-2 1.71-2.94.745l-1.81-1.86c-.94-.965-.482-2.587.825-2.918l2.515-.638Z"
            fill="url(#t)"
          />
          <path
            d="M90.475 34.583H35.183a2.082 2.082 0 0 0-2.085 2.08c0 1.148.934 2.079 2.085 2.079h55.292a2.082 2.082 0 0 0 2.085-2.08c0-1.148-.933-2.08-2.085-2.08Z"
            fill="url(#u)"
          />
          <mask fill="#fff" id="v">
            <path
              clipRule="evenodd"
              d="M124.372 34.047a1.892 1.892 0 1 0 0-3.785 1.892 1.892 0 0 0 0 3.785Zm0 1.42a3.311 3.311 0 1 0 0-6.623 3.311 3.311 0 0 0 0 6.622Z"
              fillRule="evenodd"
            />
          </mask>
          <path
            d="M123.638 32.154c0-.405.328-.734.734-.734v5.253a4.519 4.519 0 0 0 4.518-4.519h-5.252Zm.734.734a.734.734 0 0 1-.734-.734h5.252a4.518 4.518 0 0 0-4.518-4.519v5.253Zm.733-.734a.733.733 0 0 1-.733.734v-5.252a4.519 4.519 0 0 0-4.519 4.518h5.252Zm-.733-.734c.405 0 .733.329.733.734h-5.252a4.519 4.519 0 0 0 4.519 4.519V31.42Zm.685.734a.686.686 0 0 1-.685.686v5.252a5.938 5.938 0 0 0 5.938-5.938h-5.253Zm-.685-.685c.378 0 .685.307.685.685h5.253a5.938 5.938 0 0 0-5.938-5.938v5.253Zm-.686.685c0-.378.307-.685.686-.685v-5.253a5.938 5.938 0 0 0-5.938 5.938h5.252Zm.686.686a.686.686 0 0 1-.686-.686h-5.252a5.938 5.938 0 0 0 5.938 5.938V32.84Z"
            fill="#6C737F"
            mask="url(#v)"
          />
          <g filter="url(#w)">
            <path
              d="M118.621.5h-32.52a2.742 2.742 0 0 0-2.744 2.74V18.5a2.742 2.742 0 0 0 2.744 2.74h32.52a2.742 2.742 0 0 0 2.744-2.74V3.24A2.742 2.742 0 0 0 118.621.5Z"
              fill="url(#x)"
            />
          </g>
          <path
            d="M113.93 14.018a3.152 3.152 0 0 0 3.154-3.15c0-1.74-1.412-3.15-3.154-3.15a3.152 3.152 0 0 0-3.155 3.15c0 1.74 1.412 3.15 3.155 3.15ZM102.656 14.018a3.152 3.152 0 0 0 3.155-3.15c0-1.74-1.412-3.15-3.155-3.15a3.152 3.152 0 0 0-3.154 3.15c0 1.74 1.412 3.15 3.154 3.15ZM91.383 14.018a3.152 3.152 0 0 0 3.155-3.15c0-1.74-1.412-3.15-3.155-3.15a3.152 3.152 0 0 0-3.154 3.15c0 1.74 1.412 3.15 3.154 3.15Z"
            fill="#6C737F"
          />
          <path
            d="M13.051 9.573c.494-2.046 3.404-2.046 3.898 0a2.004 2.004 0 0 0 1.478 1.478c2.046.494 2.046 3.404 0 3.898a2.004 2.004 0 0 0-1.478 1.478c-.494 2.046-3.404 2.046-3.898 0a2.004 2.004 0 0 0-1.478-1.478c-2.046-.494-2.046-3.404 0-3.898a2.004 2.004 0 0 0 1.478-1.478Z"
            fill="url(#y)"
          />
          <mask fill="#fff" id="z">
            <path
              clipRule="evenodd"
              d="M61.14 6.484a1.892 1.892 0 1 0 0-3.785 1.892 1.892 0 0 0 0 3.785Zm0 1.42a3.312 3.312 0 1 0 0-6.624 3.312 3.312 0 0 0 0 6.624Z"
              fillRule="evenodd"
            />
          </mask>
          <path
            d="M60.407 4.592c0-.405.328-.734.734-.734v5.253a4.519 4.519 0 0 0 4.518-4.519h-5.252Zm.734.734a.734.734 0 0 1-.734-.734h5.252A4.519 4.519 0 0 0 61.14.073v5.253Zm.733-.734a.734.734 0 0 1-.733.734V.073a4.519 4.519 0 0 0-4.52 4.519h5.253Zm-.733-.734c.405 0 .733.329.733.734h-5.252a4.519 4.519 0 0 0 4.519 4.519V3.858Zm.685.734a.686.686 0 0 1-.685.686v5.252a5.938 5.938 0 0 0 5.938-5.938h-5.253Zm-.685-.686c.378 0 .685.307.685.686h5.253a5.938 5.938 0 0 0-5.938-5.938v5.252Zm-.686.686c0-.379.307-.686.686-.686v-5.252a5.938 5.938 0 0 0-5.939 5.938h5.253Zm.686.686a.685.685 0 0 1-.686-.686h-5.253a5.938 5.938 0 0 0 5.939 5.938V5.278Z"
            fill="#6C737F"
            mask="url(#z)"
          />
        </g>
        <defs>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="a"
            x1="63.231"
            x2="64.499"
            y1="-15.662"
            y2="202.032"
          >
            <stop stopColor="white" stopOpacity="0" />
            <stop offset="1" stopColor="#9DA4AE" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="b"
            x1="20.57"
            x2="105.007"
            y1="20.736"
            y2="26.699"
          >
            <stop stopColor="#9DA4AE" />
            <stop offset="1" stopColor="#6C737F" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="c"
            x1="18.134"
            x2="139.92"
            y1="82.616"
            y2="84.784"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="d"
            x1="30.583"
            x2="96.077"
            y1="91.58"
            y2="91.58"
          >
            <stop stopColor="#6C737F" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="e"
            x1="30.583"
            x2="96.077"
            y1="73.91"
            y2="73.91"
          >
            <stop stopColor="#6C737F" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="f"
            x1="-.057"
            x2="54.86"
            y1="104.054"
            y2="104.706"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="g"
            x1="6.403"
            x2="34.424"
            y1="109.369"
            y2="109.369"
          >
            <stop stopColor="#6C737F" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="h"
            x1="6.403"
            x2="34.424"
            y1="99.101"
            y2="99.101"
          >
            <stop stopColor="#6C737F" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="i"
            x1="102.575"
            x2="110.626"
            y1="102.652"
            y2="93.807"
          >
            <stop stopColor="#9DA4AE" />
            <stop offset="1" stopColor="#6C737F" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="j"
            x1="95.838"
            x2="102.813"
            y1="113.102"
            y2="120.36"
          >
            <stop stopColor="#9DA4AE" />
            <stop offset="1" stopColor="#6C737F" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="k"
            x1="6.172"
            x2="34.436"
            y1="89.827"
            y2="89.827"
          >
            <stop stopColor="#6C737F" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="l"
            x1="7.141"
            x2="20.408"
            y1="79.529"
            y2="79.529"
          >
            <stop stopColor="#6C737F" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="m"
            x1="30.583"
            x2="96.077"
            y1="56.24"
            y2="56.24"
          >
            <stop stopColor="#6C737F" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="n"
            x1="47.017"
            x2="114.183"
            y1="56.648"
            y2="57.085"
          >
            <stop stopColor="#9DA4AE" />
            <stop offset="1" stopColor="#6C737F" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="o"
            x1="48.474"
            x2="71.625"
            y1="109.808"
            y2="109.958"
          >
            <stop stopColor="#9DA4AE" />
            <stop offset="1" stopColor="#6C737F" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="q"
            x1="80.456"
            x2="108.842"
            y1="46.382"
            y2="120.156"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#D2D6DB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="s"
            x1="118.104"
            x2="125.353"
            y1="62.16"
            y2="55.176"
          >
            <stop stopColor="#9DA4AE" />
            <stop offset="1" stopColor="#6C737F" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="t"
            x1="5.838"
            x2="12.813"
            y1="48.102"
            y2="55.36"
          >
            <stop stopColor="#9DA4AE" />
            <stop offset="1" stopColor="#6C737F" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="u"
            x1="30.583"
            x2="96.077"
            y1="38.57"
            y2="38.57"
          >
            <stop stopColor="#6C737F" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="x"
            x1="82.216"
            x2="137.096"
            y1="16.053"
            y2="17.643"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#E5E7EB" />
          </linearGradient>
          <linearGradient
            gradientUnits="userSpaceOnUse"
            id="y"
            x1="3.474"
            x2="26.625"
            y1="6.808"
            y2="6.958"
          >
            <stop stopColor="#9DA4AE" />
            <stop offset="1" stopColor="#6C737F" />
          </linearGradient>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="89.755"
            id="p"
            width="89.843"
            x="35.535"
            y="29.707"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImageFix" stdDeviation="8.338" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_5_57400" />
            <feBlend
              in="SourceGraphic"
              in2="effect1_backgroundBlur_5_57400"
              mode="normal"
              result="shape"
            />
          </filter>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="47.688"
            id="r"
            width="80.688"
            x="40.656"
            y="65.656"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feBlend in="SourceGraphic" in2="BackgroundImageFix" mode="normal" result="shape" />
            <feGaussianBlur result="effect1_foregroundBlur_5_57400" stdDeviation="10.422" />
          </filter>
          <filter
            colorInterpolationFilters="sRGB"
            filterUnits="userSpaceOnUse"
            height="46.741"
            id="w"
            width="64.008"
            x="76.357"
            y="-8.5"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              result="hardAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dx="6" dy="4" />
            <feGaussianBlur stdDeviation="6.5" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
            />
            <feBlend in2="BackgroundImageFix" mode="normal" result="effect1_dropShadow_5_57400" />
            <feBlend
              in="SourceGraphic"
              in2="effect1_dropShadow_5_57400"
              mode="normal"
              result="shape"
            />
          </filter>
        </defs>
      </svg>
    </SvgIcon>
  );
}
